module.exports = __webpack_public_path__ + "img/game2.62f285b6.png";